import { Route } from '@angular/router';
import LayoutComponent from './layout/layout.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/home/home.page'),
      },
      {
        path: 'loading',
        loadComponent: () => import('./pages/loading/loading.page'),
      },
      {
        path: 'event',
        loadComponent: () => import('./pages/event-list/event-list.page'),
      },
      {
        path: 'event/:eventId/registration',
        loadComponent: () =>
          import('./pages/registration-form/registration-form.page'),
      },
      {
        path: 'registration-complete',
        loadComponent: () =>
          import('./pages/registration-complete/registration-complete.page'),
      },
    ],
  },
];
